import { useEffect, useState } from "react"

import If from "../if"
import InputURL from "./input-url"
import ListItem from "./list-item"
import BBModal from "../modal"
import {
  useAddApprovedUrlMutation,
  useFetchApprovedUrlsQuery
} from "../../../redux/queries"
import { selectUserDetails } from "../../../redux/slices/auth"
import { useAppSelector } from "../../hooks"
import { UserDetails } from "../../../types"

type Props = {
  show: boolean
  toggleModal: (show: boolean) => void
  /** Override the org id (defaults to the current user's org). */
  orgId?: string
}

const ApprovedUrlsModal = ({ show, toggleModal, orgId }: Props) => {
  const [newURL, setNewURL] = useState("")

  const user: UserDetails | any = useAppSelector(selectUserDetails)
  const targetOrgId = orgId ?? user?.org?.id

  const [addApprovedUrl, { isLoading }] = useAddApprovedUrlMutation()

  const { data: approvedURLs, isFetching } = useFetchApprovedUrlsQuery(
    targetOrgId ?? "",
    {
      skip: !targetOrgId || !show
    }
  )

  useEffect(() => {
    if (!isLoading) {
      setNewURL("")
    }
  }, [isLoading])

  const onClose = () => {
    setNewURL("")
    toggleModal(false)
  }

  const onSubmit = () => {
    addApprovedUrl({ org_id: targetOrgId, domain_pattern: newURL })
  }

  return (
    <BBModal show={show} onClose={onClose} title="Approved URL's">
      <div className="-mt-2">
        <div>
          <label htmlFor="new-url" className="sr-only">
            Add new URL
          </label>
          <InputURL
            resetInputOnSubmit
            id="new-url"
            url={newURL}
            onChange={setNewURL}
            onSubmit={onSubmit}
            isLoading={isLoading}
          />
        </div>
        <div
          className={`border-t border-zinc-200 mt-3 ${
            isFetching ? "pt-3" : ""
          }`}
        >
          <If
            isLoading={isFetching}
            condition={!!approvedURLs && approvedURLs?.length > 0}
            then={
              <ul className="max-h-96 overflow-auto">
                {approvedURLs?.map((url, index) => (
                  <ListItem key={index} url={url} />
                ))}
              </ul>
            }
            else={
              <p className="text-neutral-400 italic text-sm">
                There are no approved URLs.
              </p>
            }
          />
        </div>
      </div>
    </BBModal>
  )
}
export default ApprovedUrlsModal
